<template>
  <v-dialog width="573px" persistent v-model="dialog">
    <template #activator="{ on: dialog }">
      <v-tooltip bottom open-delay="500" color="#5774E7">
        <template #activator="{ on: tooltip, attrs }">
          <div v-on="tooltip">
            <v-btn class="mx-1 pa-2 btn" v-on="dialog" v-bind="attrs" elevation="0" height="32px" width="32px" x-small color="white"><v-icon color="#5774E7" v-text="'mdi-cog'"></v-icon> </v-btn>
          </div>
        </template>
        <span>Manage your results settings</span>
      </v-tooltip>
    </template>
    <v-card>
      <v-card-title>
        <h3 class="header">Manage your results settings</h3>
      </v-card-title>
      <div class="options-container">
        <v-radio-group hide-details v-model="options" class="py-0"  column>
          <div class="radio-option">
            <v-radio color="info" value="today"></v-radio>
            <span class="option-text font-weight-medium">Select the results from the last 24 hours</span>
          </div>
          <div class="radio-option">
            <v-radio color="info" value="date"></v-radio>
            <span class="option-text font-weight-medium">Select the results from a specific date</span>
            <v-dialog max-width="300px" persistent v-model="modal">
              <template v-slot:activator="{ on: { click } }">
                <v-text-field prepend-inner-icon="mdi-calendar" v-on:click="click" v-on:click:prepend-inner="click"class="date" variant="solo" readonly v-model="dateText" required></v-text-field>
                <!-- <div class="cal-btn-container">
                  <v-btn class="mx-0 btn" v-on:click="click" elevation="0" height="32px" width="32px" x-small color="white"><v-icon color="#5774E7" v-text="'mdi-calendar'"></v-icon> </v-btn>
                </div> -->
              </template>
              <v-date-picker v-model="date" scrollable actions>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" @click="cancelDatePicker">Cancel</v-btn>
                  <v-btn color="primary" @click="okDatePicker">OK</v-btn>
                </v-card-actions>
              </v-date-picker>
            </v-dialog>
          </div>
          <div class="radio-option">
            <v-radio color="info" value="all"></v-radio>
            <span class="option-text font-weight-medium">Select all the results</span>
          </div>
        </v-radio-group>
      </div>

      <v-card-actions class="px-5">
        <v-spacer></v-spacer>
        <v-btn width="100px" @click="cancelButton"> Cancel </v-btn>
        <v-btn width="100px" @click="okButton"> Ok </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  setup() {},
  mounted() {},

  data: () => ({
    dialog: false,
    options: "today",
    originalOption: "today",
    modal: false,
    date: new Date().toISOString().substr(0, 10),
    dateText: new Date().toISOString().substr(0, 10),
  }),
  methods: {
    cancelDatePicker() {
      this.modal = false;
    },
    okDatePicker() {
      this.dateText = this.date;
      this.modal = false;
    },
    okButton() {
      this.dialog = false;
      this.$emit("updateOptions", { option: this.options, date: this.date });
    },
    cancelButton() {
      this.options = this.originalOption;
      this.dialog = false;
    },
  },
  watch: {
    dialog(val) {
      if (val == true) {
        this.originalOption = this.options;
      }
    },
  },
};
</script>

<style scoped>
.cal-btn-container {
  position: absolute;
  left: 360px;
  top: 35px;
}
.date {
  position: absolute;
  left: 330px;
  top: 35px;
}
.header {
  color: #373737;
}
.option-text {
  padding-left: 12px;
}
.options-container {
  padding-left: 12px;
  border-top: 1px solid #c3c3c3;
}
.radio-option {
  display: flex;
  padding-top: 12px;
}

</style>
